<template>
	<el-popover
		style="margin-top: auto; margin-bottom: auto"
		placement="bottom"
		trigger="click"
		@close="allNot = false"
	>
		<div slot="reference">
			<md-button style="margin-top: auto; margin-bottom: auto" class="md-icon-button">
				<el-badge is-dot class="item" :hidden="notifications.length === 0">
					<md-icon>notifications</md-icon>
				</el-badge>
			</md-button>
		</div>

		<div class="notifications-container">
			<div>
				<div
					v-if="notifications.length > 0"
					@click="gotolink(notification)"
					v-for="(notification, index) of notifications"
					:key="index"
				>
					<div class="notification">
						<div class="right">
							<div class="icon" :style="{ 'background-color': calcBack(notification.type) }">
								<md-icon :style="{ color: calcAccent(notification.type) }">
									{{ calcIcon(notification.type) }}
								</md-icon>
							</div>
						</div>
						<div class="left">
							<div class="content">
								<div class="text" :style="{ color: calcAccent(notification.type) }">
									{{ notification.title }}
								</div>
								<div class="body">{{ notification.body }}</div>
							</div>
						</div>
					</div>
					<div class="see-more">
						<div
							class="button read"
							@click="
								setAsRead(notification.id)
								moveToRead(notification.code)
							"
							:style="{ color: calcAccent(notification.type) }"
						>
							{{ $t("mark-read") }}
						</div>
					</div>
				</div>

				<div v-if="notifications.length === 0" style="background: transparent; box-shadow: none">
					<div class="notification">
						<div class="right">
							<div class="icon">
								<md-icon>check</md-icon>
							</div>
						</div>
						<div class="left">
							<div class="content">
								<div class="text">{{ $t("thats-all-folks") }}</div>
								<div class="body">{{ computedDate }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="separator">
					<div class="line"></div>
				</div>

				<div class="see-more">
					<div class="content">
						<div class="button more" @click="allNot = !allNot">
							{{ !allNot ? $t("see-all") : $t("hide-all") }}
						</div>
						<div class="button more" @click="allDelete()" v-if="allNot" style="color: #ff4d4d">
							{{ $t("delete-all") }}
						</div>
						<div class="button more" @click="allRead()" v-else style="color: #80aaff">
							{{ $t("mark-all-as-read") }}
						</div>
						<!-- <el-button @click="allDelete()" type="primary" v-if="allNot">
							{{ $t("delete-all") }}
						</el-button> -->
						<!-- <el-button @click="allRead()" type="primary" v-else>
							{{ $t("mark-all-as-read") }}
						</el-button> -->
					</div>
				</div>

				<div v-if="allNot">
					<div v-for="(notification, index) of read_notifications" :key="index">
						<div class="notification">
							<div class="right">
								<div
									class="icon"
									:style="{ 'background-color': calcBack(notification.type) }"
									@click="handleCheckout(notification.code)"
								>
									<el-tooltip :content="$t('delete')" :open-delay="300">
										<md-icon
											:style="{ color: calcAccent(notification.type) }"
											style="cursor: pointer"
											>delete
										</md-icon>
									</el-tooltip>
								</div>
							</div>
							<div class="left">
								<div class="content">
									<div class="text" :style="{ color: calcAccent(notification.type) }">
										{{ notification.title }}
									</div>
									<div class="body">{{ notification.body }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-popover>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import moment from "moment"
import axios from "axios"
import { uuid } from "@/modules/builder/utils/utils"
import { iOS } from "@/utils/utils"

export default {
	name: "Notifications",
	data() {
		return {
			is_focused: true,
			allNot: false,
			connection: undefined
		}
	},
	beforeDestroy() {
		this.connection = undefined
	},
	computed: {
		...mapGetters({
			user: "user/user",
			approved: "user/approved",
			roles: "user/roles",
			username: "user/username",
			modules: "user/modules",
			organizationModules: "organization/modules",
			isSuperAdmin: "user/isSuperAdmin",
			subscriptions: "organization/subscriptions",
			notifications: "user/notifications",
			read_notifications: "user/read_notifications",
			active_subscription: "organization/active_subscription"
		}),
		computedDate() {
			return moment().format("DD MMM")
		}
	},
	created: function () {
		this.connect()
		window.onfocus = () => {
			this.is_focused = true
		}
		window.onblur = () => {
			this.is_focused = false
		}

		this.downloadUnread()
	},
	methods: {
		iOS,
		gotolink(not) {
			if (not.link) {
				this.$goTo(not.link)
			}
		},
		allRead() {
			this.notifications.forEach(notification => {
				this.setAsRead(notification.id)
				this.moveToRead(notification.code)
			})
		},
		allDelete() {
			this.read_notifications.forEach(notification => {
				this.handleCheckout(notification.code)
			})
		},
		calcBack(name) {
			switch (name) {
				case "success":
					return "rgba(103, 194, 58, 0.4)"
					break
				case "warning":
					return "rgba(244, 126, 0, 0.4)"
					break
				case "danger":
					return "rgba(245, 108, 108, 0.4)"
					break
				case "info":
					return "rgba(138, 131, 131, 0.4)"
				default:
					return "rgba(138, 131, 131, 0.4)"
					break
			}
		},
		calcIcon(name) {
			switch (name) {
				case "success":
					return "check"
				case "warning":
					return "warning"
				case "danger":
					return "error"
				case "info":
					return "info"
				default:
					return ""
			}
		},
		calcAccent(name) {
			switch (name) {
				case "success":
					return "rgba(103, 194, 58, 0.7)"
				case "warning":
					return "rgba(244, 126, 0, 0.7)"
				case "danger":
					return "rgba(245, 108, 108, 0.7)"
				case "info":
					return "rgba(138, 131, 131, 0.7)"
				default:
					return ""
			}
		},
		...mapActions({
			doLogout: "user/doLogout",
			doOrganizationModules: "organization/doModules",
			addNotifications: "user/addNotifications",
			removeNotifications: "user/removeNotifications",
			moveNotifications: "user/moveNotifications"
		}),
		handleCheckout: function (index) {
			this.removeNotifications(index)
		},
		moveToRead: function (index) {
			this.moveNotifications(index)
		},
		sendMessage: function (message) {
			this.connection.send(message)
		},
		setAsRead(id) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/notification/setAsRead",
					{ id: id },
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {})
				.catch(err => {})
		},
		connect() {
			if (!this.connection) {
				// let ws = "ws://" + process.env.VUE_APP_API_URL.replace("https://", "") + "/ws"
				let ws = undefined
				if (process.env.VUE_APP_API_URL.includes("http://"))
					ws = "ws://" + process.env.VUE_APP_API_URL.replace("http://", "") + "/ws"
				else ws = "wss://" + process.env.VUE_APP_API_URL.replace("https://", "") + "/ws"

				this.connection = new WebSocket(ws)

				let auth = false
				this.connection.onmessage = event => {
					if (auth) {
						var data = JSON.parse(event.data)

						this.addNotifications({
							id: data.id,
							title: this.$t(data.title),
							body: this.$t(data.body),
							type: data.type ? data.type : "info",
							code: data.code ? data.code : uuid(),
							read: data.code ? data.read : false,
							link: data.link ? data.link : ""
						})
						if (data.type == "danger") {
							data.type = "error"
						}
						// if (this.is_focused) {
						this.$notification(
							data.type ? data.type : "info",
							this.$t(data.title),
							this.$t(data.body),
							5000,
							"top-right",
							false,
							() => {
								this.$goTo(data.link)
							}
						)
						// } else {
						if (!this.iOS())
							new Notification(this.$t(data.title), { body: this.$t(data.body), icon: "/logo.png" })
						// }
					} else {
						if (event.data.includes("bearer")) {
							axios
								.post(
									process.env.VUE_APP_API_URL + "/ws/auth",
									{ token: event.data.replace("bearer ", "") },
									{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
								)
								.then(res => {
									if (res.data.accepted) {
										auth = true
									} else {
										this.connection.close()
									}
								})
								.catch(err => {
									console.error("errore di autenticazione")
									this.connection.close()
								})
						}
					}
				}

				this.connection.onopen = event => {}
				this.connection.onerror = err => {
					this.addNotifications({
						id: uuid(),
						title: this.$t("error"),
						body: this.$t("error-notification-connection"),
						type: "danger",
						code: uuid(),
						read: false
					})

					// if (this.is_focused) {
					this.$notification("error", this.$t("error"), this.$t("error-notification-connection"))
					// } else {
					new Notification(this.$t("error"), {
						body: this.$t("error-notification-connection"),
						icon: "/logo.png"
					})
					this.connection.close()
				}

				this.connection.onclose = event => {
					// this.addNotifications({
					// 	id: uuid(),
					// 	title: this.$t("error"),
					// 	body: this.$t("error-notification-connection"),
					// 	type: "danger",
					// 	code: uuid(),
					// 	read: false
					// })
					//
					// // if (this.is_focused) {
					// this.$notification("error", this.$t("error"), this.$t("error-notification-connection"))
					// // } else {
					// new Notification(this.$t("error"), {
					// 	body: this.$t("error-notification-connection"),
					// 	icon: "/logo.png"
					// })
				}
			}
		},
		downloadUnread() {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/notification/get",
					{},
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					if (res.data.list) {
						res.data.list.forEach(not => {
							this.addNotifications({
								id: not.id,
								title: this.$t(not.title),
								body: this.$t(not.body),
								type: not.type ? not.type : "info",
								code: not.code ? not.code : uuid(),
								read: not.read,
								link: not.link
							})
						})
					}
				})
				.catch(err => {
					console.error("unable to download notifications")
				})
		}
	}
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/notifications.scss";
</style>
